import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

const optionName = option => typeof option === 'string' ? option : option?.name || '';

// Keep API values as strings (or arrays of strings), including newly typed values.
export default function ProductSelect({ value, onChange, options = [], multiple = false,
  label, required = false, ...props }) {
  return <Autocomplete
    {...props}
    fullWidth
    multiple={multiple}
    freeSolo
    autoSelect
    forcePopupIcon
    options={options}
    value={multiple ? (Array.isArray(value) ? value : []) : (value || null)}
    {...(!multiple ? { inputValue: value || '' } : {})}
    getOptionLabel={optionName}
    isOptionEqualToValue={(option, selected) => optionName(option) === optionName(selected)}
    onInputChange={(_event, input, reason) => {
      if (!multiple && (reason === 'input' || reason === 'clear')) onChange(input);
    }}
    onChange={(_event, selected) => onChange(multiple
      ? [...new Set(selected.map(optionName).map(name => name.trim()).filter(Boolean))]
      : optionName(selected))}
    renderInput={params => <TextField {...params} label={label} required={required} />}
  />;
}
